export const viewTitle = "Построенные отчёты";
export const viewUniqKey = "generatedReports";
